import { useQuery } from '@tanstack/react-query';
import { SearchDocumentError, SearchDocumentResponse } from '@models/searchDocument/SearchDocument';
import { QueryKey } from '@constants/queryKey';
import { minutesToMillis } from '@utils/millis';
import { searchDocument } from '@repository/searchDocumentRepository';
import { useAtomValue } from 'jotai';
import { SearchQueryAtom } from '@js/store/searchAtoms';

const useSearchDocument = (docClass: string) => {
    const query = useAtomValue(SearchQueryAtom);

    return useQuery<SearchDocumentResponse, SearchDocumentError>({
        queryKey: [QueryKey.SearchResult, docClass, query],
        queryFn: ({ signal }) => searchDocument(docClass, query, { signal }),
        staleTime: minutesToMillis(30),
        enabled: !!docClass && query.values.length > 0,
    });
};

export default useSearchDocument;
